import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import ModalPopup from '@ui/components/VnModal';
import { addOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import ContactPersonForm from './ContactPersonForm';
import { useParams } from 'react-router-dom';
import VnGrid from '@ui/components/VnGrid';
import ContactPersonTable from './ContactPersonTable';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getContactPersonsByCreditorIdAsync } from '@application/features/creditures/creditureThunk';
import { clearSingleCrediture } from '@application/features/creditures/creditureSlice';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
const ContactPersonTab = ({ isContactPersonTabBold }) => {
    const [isContactPersonFormOpen, SetisContactPersonFormOpen] = useState(false);
    const dispatch = useAppDispatch();
    const { contactPersons } = useAppSelector((state) => state.crediture);
    function oncloseClicked() {
        SetisContactPersonFormOpen(false);
        dispatch(clearSingleCrediture());
    }
    function onRowClick() {
        SetisContactPersonFormOpen(true);
    }
    const { id } = useParams();
    useEffect(() => {
        if (id) {
            dispatch(getContactPersonsByCreditorIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                if (isContactPersonTabBold && res.length > 0) {
                    isContactPersonTabBold(true);
                }
                else {
                    isContactPersonTabBold && isContactPersonTabBold(false);
                }
            });
        }
    }, [id]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'vn-Material-Add-buttons', children: _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button', icon: addOutline, onClick: () => SetisContactPersonFormOpen(true), isDisabled: !handleRolePermission(Permission.LEVERANCIERS, PermissionType.Create), children: "Toevoegen Contactpersoon" }) }), _jsx("div", { className: 'mt-2', children: _jsx(VnGrid, { children: _jsx(ContactPersonTable, { contactPersons: contactPersons, onRowClick: onRowClick }) }) }), _jsx(ModalPopup, { title: 'Toevoegen Contactpersoon', content: _jsx(ContactPersonForm, { onClose: oncloseClicked, isContactPersonTabBold: isContactPersonTabBold }), onOpen: isContactPersonFormOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' })] }));
};
export default ContactPersonTab;
